export default function sortArtifactFilesByName(files) {
	if (!files) {
		throw new Error("No files were provided to sortArtifactFiles");
	}

	return [...files].sort((a, b) => {
		return a.name.localeCompare(b.name, undefined, { numeric: true });
	});
}
